<!-- 
Dialog for performing a raise invoice task for a levy collection provider.

Allows the default invoice due date to be overridden.
-->
<template>
  <dialog-base
    ref="base"
    v-model="show"
    :levy-collection-id="levyCollectionId"
    :provider-id="providerId"
    :task="task"
    user-guide-topic="levy-collection-providers"
    user-guide-section="running-a-levy-collection-provider-task"
    @run="validateAndRun"
    @hide="hide"
  >
    <our-date-picker
      v-model="due"
      label="Due*"
      required
      current-or-future
      autofocus
    />
  </dialog-base>
</template>

<script>
import DialogBase from "./DialogBase.vue";
import mixins from "./mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import moment from "moment";

export default {
  components: { DialogBase },
  mixins: [mixins, lookupMixins],
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        const days = this.lookups.allLevyCollections.find(c => c.id == this.levyCollectionId)
          .daysInvoiceIsDueAfterGeneratingInvoice;
        this.due = moment()
          .startOf("day")
          .add(days, "day")
          .format("YYYY-MM-DD");
      }
    }
  },
  methods: {
    validateAndRun() {
      if (this.$refs.base.validate()) {
        this.run();
      }
    }
  }
};
</script>
